import React from 'react';
import { Box } from '@mui/material';
import { ButtonUI, DeleteDialogUI, DialogUI, FileTabUI, FileUploadUI } from '../Interface';

const EmployeeAttendanceMyReportsAttachments = ({ dialogData, handleClose }) => {
  const { open, attachments } = dialogData;

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Csatolmányok"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <Box mt="1rem">
        <FileTabUI savedFiles={attachments} />
      </Box>
    </DialogUI>
  );
};

export default EmployeeAttendanceMyReportsAttachments;
